/**
 * Google Maps JavaScript API anahtari (Arac Takip ve Sefer Guzergahi haritalari ortak kullanir).
 * Kodda tutulmaz: derlemede REACT_APP_GOOGLE_HARITA_ANAHTARI ortam degiskeninden gelir
 * (GitHub secret GOOGLE_HARITA_ANAHTARI; yerelde .env.local). Anahtar sirket Google projesinde,
 * yalniz Keylogx adresleriyle ve Maps JavaScript API ile kisitli.
 */
export const GOOGLE_HARITA_ANAHTARI = process.env.REACT_APP_GOOGLE_HARITA_ANAHTARI ?? "";
